import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=25e05189&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageLayout.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=25e05189&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e05189",
  null
  
)

export default component.exports